
* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;

  padding-top: calc(var(--spacer) * 3);
  padding-bottom: calc(var(--spacer) * 3);
}

.wrapper {
  padding: 2px;
}
